import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { confirmationRegisterClean, confirmUserEmail } from '../../app/actions/authActions';
import { useTranslation } from 'react-i18next';
import { debugLogPages } from '../../app/helpers/debugHelper';

const ConfirmationAccount = () => {
    debugLogPages('---> ConfirmationAccount');
    const { token } = useParams();
    const dispatch = useDispatch();
      const { t } = useTranslation();

    const { isSuccessConfirmation, isFailedConfirmationError, isFailedConfirmationValidation } = useSelector((state) => state.auth);

    useEffect(() => {
        dispatch(confirmationRegisterClean);

        if (token) {
            //console.log("llamar al servicio de token", token)
            dispatch(confirmUserEmail(token));
        }

    }, [token])

    return (
        <div>
            {isSuccessConfirmation ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <i className="fa fa-check-circle" style={{ fontSize: '3rem', color: 'green' }}></i>
                    <h2 style={{ marginTop: '15px' }}>{t('alerts.titles.success-confirmation')}</h2>
                    <span>{t('general.success-confirmation')}</span>
                </div>
            ) : ( 
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <i className="fa fa-exclamation-circle" style={{ fontSize: '3rem', color: 'red' }}></i>
                    <h2 style={{ marginTop: '15px' }}>{t('alerts.titles.failed-confirmation')}</h2>
                    {isFailedConfirmationError && (
                        <span>{t('general.failed-confirmation-error')}</span>
                    )}
                    {isFailedConfirmationValidation && (
                        <span>{t('general.failed-confirmation-validation')}</span>
                    ) }
                </div>
            )}
        </div>
    );
}

export default ConfirmationAccount